import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';

import { NgZone } from '@angular/core';
import {defined,consts,UnlockTypes} from './appDefs';
import {SettingsRec} from './settings/SettingsRec';
import { InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';
import { Features } from './appDefs';
import { Capacitor } from '@capacitor/core';
import { Device,DeviceInfo} from '@capacitor/device';
import {App,AppInfo} from '@capacitor/app';
import { publishFacade } from '@angular/compiler';
import {Event,Events} from './Events.service';
import { Preferences  as Storage } from '@capacitor/preferences';
import { HttpClient } from '@angular/common/http';
import { Preferences } from '@capacitor/preferences';
import { Network } from '@capacitor/network';
import { ProductItem,ProductStatus,ProductType,productCatalog } from './purchase/productList';
import { Observable } from 'rxjs';
declare var window :any;

//const FREE_DAYS =2;
export const FREE_DAYS =2;
export const AdWatchOffer="( 1 calendar day)";

import { GoogleAnalyticsService } from 'ngx-google-analytics';

// Install TypeScript wrapper

//import { Purchases  } from "@awesome-cordova-plugins/purchases/ngx";
/*import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { OAuthProvider,getAuth,signInAnonymously,onAuthStateChanged, setPersistence,browserLocalPersistence,User,UserInfo } from "firebase/auth";

import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAL6e28H8WrpKahfcrqTq_KsFrBnZjplq8",
  authDomain: "raagastudio-3c7be.firebaseapp.com",
  projectId: "raagastudio-3c7be",
  storageBucket: "raagastudio-3c7be.appspot.com",
  messagingSenderId: "449423184670",
  appId: "1:449423184670:web:1c6629e58dad30d70a6f0f",
  measurementId: "G-ERBTDFQCQT"
};


// Initialize Firebase

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth=getAuth();
*/
export class Usage 
  {
    label:"";
    param2:"";
    time:0;
    count;
    date:"";
  }

export enum SettingCategory{ 

  INSTR="Instrument",
  COMPRESSOR="Compressor",
  EQUALIZER="Equalizer",
  REVERB="Reverb",
  PAN="Pan"


}

class SettingsStore {

  name=null;
  instrList=null;
  compressorList=[];
  equalizerList=[];
  reverbList=[];
  panList=[];
 
  validCategory(cat)
  {
let valid=(cat==SettingCategory.INSTR)||
    (cat=SettingCategory.COMPRESSOR)||
    (cat==SettingCategory.EQUALIZER)
||
    (cat=SettingCategory.REVERB)
|| (cat==SettingCategory.PAN) ;
    return valid;
}
  constructor ()
  {
    this.listGet(SettingCategory.COMPRESSOR).then ((a)=>{
      this.compressorList=a as [];
    });
   this.listGet(SettingCategory.EQUALIZER).then((a)=>{
     this.equalizerList= a as [];
    });
  this.listGet(SettingCategory.REVERB).then((a)=>{
    this.reverbList=a as [];
  });
    this.listGet(SettingCategory.INSTR).then ((a)=>{this.instrList=a as []});
  
  }
 


  get(cat,name) :any
  {
    if (!this.validCategory(cat))
    {
      return;
    }
    let list=this.listByCat(cat);
   let  result=list.find(a=>(a.name==name));
   if (result)
    return result;
  return null;
  }
  addNew (cat,name,value)
  { if (!this.validCategory(cat))
    {
      return ;
    }
      let exists=this.get(cat,name);
      if (exists)
      {
        return "Already exists";
      }
      let list=this.listByCat(cat);
      let cts=list.filter((a)=>{{ return ( a.name == name)}});
      if (cts.length >0)
      {
        console.log('Exists');
        return;
      }
      list.push({name:name,value:value});
       this.listPut(cat,list);
  }
  update (cat,name,value)
  {
    if (!this.validCategory(cat))
    {
      return;
    }
    let exists=this.get(cat,name);
    if (exists)
    {
      exists.value=value;
    }
    let list=this.listByCat(cat);
    this.listPut(cat,list);
  }
  listByCat(cat)
  {
    if (!this.validCategory(cat))
    {
      return;
    }
    if (cat==SettingCategory.COMPRESSOR)
    return this.compressorList;
    if (cat==SettingCategory.REVERB)
    return this.reverbList;
    if (cat==SettingCategory.EQUALIZER)
    return this.equalizerList;
    
    if (cat==SettingCategory.PAN)
    return this.panList;
    if (cat==SettingCategory.INSTR)
    return this.instrList;
    return null;
  }
 
  async listGet(cat,option?:any)
  {
    let newProm=new Promise((resolve,reject)=>{

    
    if (!this.validCategory(cat))
    {
      return;
    }
    // JSON "set" example
    let key=cat;
 
   Storage.get({
        key: key
        
        }).then ((resultPar)=>{

       

       
          let result=JSON.parse(resultPar.value);
          if (result)
          resolve(result)
          else
          resolve([]);
       
    }).catch((e)=>{resolve([])});
    


    
  });
  return newProm;

}
async listPut(cat,value)
{
  // JSON "set" example
  let key=cat;
  let result=null;
  if (!this.validCategory(cat))
  {
    return;
  }
  let myList=
    await Storage.set({
      key: cat,
      value:JSON.stringify(value)
      
      }) ;
  



   

}

}

class Product
{
  name:string;
  id:string;
  currency?:string;
  state?:string;
  type?:string;
  billingPeriod?:number;
  billingPeriodUnit?:string;
  price?:string;
  loaded?:boolean;
  owned?:boolean;
  introPrice?:string;
  introPricePeriod?:number;
  introPricePeriodUnit?:string;
  introPricePayment?:string;
  priceMicros:number;
  introPriceMicros:number;
  expiryDate?:Date;
  lastRenewalDate?:Date;
  purchaseDate:Date;


  
}

// set to landscape

declare var window:any;

enum Member {
  
  Bronze = "Bronze",
  Silver = "Silver",
  Gold = "Gold",
  Platinum = "Platinum",
}

/*
class RevenuCat {

  
  constructor(public platform: Platform,private purchases:Purchases) {
      platform.ready().then(() => {
          this.purchases.setDebugLogsEnabled(true); // Enable to get debug logs
         this.purchases.setup("appl_LMWTBRHoLtVSsASFTpvYUVXIhqV", null);
          this.getOfferings();
      }
      
  );
    }
    offerings;

    async getOfferings ()
    {
      let prom=this.purchases.getOfferings();
      let offerings=await prom;
       console.log(offerings)
      this.offerings=offerings;
    }

}
*/
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

 

  appName="Raaga Studio";
  appLongName="RaaGa Studio by SaReGa";
  startUpShown=false;
  appDescription="......";
  appPreferences={
  leftHanded:false,
  language:'en',
  allowDeviceSizes:false,
  useNoEffects:false,
  useMaster:false,
  dualSoundBendPolicy:'PREVENT',
  //SINGLE
  dualKeyBoardTrackPolicy:'UNIFORM'
  // or 'SEPERATE'
  };
  release={
    version:'',
    date:'',

  };
  appInfo:AppInfo;
 devInfo :DeviceInfo;

 currentSettings:SettingsRec=null;
  appCapabalities={

    tabla:Member.Silver,
    taanpura:Member.Silver,
    rhythmLoop:Member.Silver,
    padLoop:Member.Gold,
    doublePiano:Member.Bronze,
    flexPiano:Member.Bronze,
    trackEffects:Member.Gold,
    bend:Member.Silver,
    outEffects:Member.Gold,
    doubleInstrument:Member.Gold,
    record:Member.Silver,
    saveMP3:Member.Gold


  };

  tablaCap={
    minMem:Member.Silver
  }


  appPurchases={};
  appGifts=[];
  app:any=null;
  checkContentAccess()
  {

  }
  deviceInfo =null;
  
  getDeviceInformation()
  {
    
    if (window && defined(window.device))
    {

      this.readyDevice=true;
      this.deviceInfo={... window.device.version};      

      alert("Device versions "+window.device.version )
  }
}  
//appInfo={version:"",name:"",packageName:"",versionCode:''};

/*
  getAppVersion()
  {

    if (defined(window.corodva))
    {
     window.cordova.getAppVersion.getVersionNumber(function (version) {
       this.appInfo.version=version;
     });
       window.cordova.getAppVersion.getAppName(function (name) {
        this.appInfo.name=name;});
        window.cordova.getAppVersion.getPacakageName(function (packageName) {
          this.appInfo.packageName=packageName;
        });
        
        window.cordova.getAppVersion.getVersionCode(function (code) {
          this.appInfo.versionCode=code;
        });   
   
        alert ("Version is this.appInfo.versionCode");

  }

  if (Capacitor.getPlatform()=='web')
  {
    let devInfo={
      platform:'web',
      operatingSystem:'browser',
      manufacturer:'browser',
      model:"",
      osVersion:"",
      isVirtual:false,
      webViewVersion:""
    }
    this.devInfo=devInfo as DeviceInfo;
  }
   else Device.getInfo().then ((devInfo)=>{
    this.devInfo=devInfo;
    console.log(this.devInfo);
  });
  
  if (App && App.getInfo)
  {
  if (Capacitor.getPlatform()!='web') App.getInfo().then ((appInfo)=>{
    this.appInfo=appInfo;
    this.app=App;
    console.log(this.appInfo);
    this.appName=this.appInfo.name;
  })
}
else
{
  alert ('Cap app Info failed');
  if (window.navigator.appInfo && window.navgator.appInfo.identifer)
    alert ('App info worked');
}


}*/
  checkMenuAccess(cap)
  {

  }
  checkFeatureAccess()
  {

  }

  usageList:any[];
  initUsage()
  {
    Preferences.get({key:'USAGE'}).then((d )=>
    {
      this.usageList=JSON.parse(d.value);

    })
  }
  logUsage(usage)
  {
this.usageList.push(Usage);
Preferences.set({key:'USAGE',value:JSON.stringify(this.usageList)})
  }
getGifts()
{

}
//productList=["BronzeMember","SilverMember","GoldMember","PlatinumMember"];


productList=["GoldMember"];
iosStore={
products:['ragaagoldquarter','goldpass'],
offers:[],
offersMap:{
  
}
};
googleStore={
  products:['raagagold','goldpass'],
  offers:['goldpass66'],
  offersMap:{
    'goldpass':['goldpass66']
  }
};
webStore={
  products:[]
}
products;
offers;
offersMap;
savedVerified=[];

storeProducts={};
storeRefreshing=false;
refreshComplete=false;
getProducts()
{
  

  let promise = new Promise ((resolve,reject)=>{

    this.store.verbosity=this.store.DEBUG;

    this.products=this.webStore.products;
  if (Capacitor.getPlatform()=='ios')
  {
   
this.products=this.iosStore.products;
this.offers=this.iosStore.offers;
this.offersMap=this.iosStore.offersMap;
  }
  if (Capacitor.getPlatform()=='android')
  {
    this.products=this.googleStore.products;
    this.offers=this.googleStore.offers;
    this.offersMap=this.googleStore.offersMap;
  }
  let platform=Capacitor.getPlatform();

  if (!((platform=='ios') || (platform=='android')))
  {

  
  reject("bad platform");
  return;
  }

  this.store.when('product').approved( (p2)=>{
    if (p2.id=='goldpass')
    {
      p2.verify();
     // p2.finish();
    }else
    p2.verify();
  });
  this.store.when('product').verified( (p2)=>{
    
    this.addToVerified({id:p2.id, expiryDate:p2.expiryDate});
    p2.finish();
  });
  this.store.when('product').unverified( (p2)=>{

    p2.finish();
  });
  this.store.when('product').expired((p2)=>{
console.log ('Expired ',p2.id)
  })
  //this.store.validator = "https://billing.fovea.cc/";
  this.store.verbosity=this.store.DEBUG;
 this.store.when('product').updated((p)=>
 {
  

  
      
   /*
      this.store.when(p).cancelled( (p2)=>{
    
        p2.finish();
      });
   
      this.store.when(p).expired( (p2)=>{
    
        p2.finish();
      });
      this.store.when(p).refunded((p2)=>{
    
        p2.finish();
      });
   */
   
    

   console.log ("product update "+p.id +' '+p.price);
   let prod :Product;
 if (!this.storeProducts[p.id])
 {
   prod=new Product();
   this.storeProducts[p.id]=prod;
 }
 else
 prod=this.storeProducts[p.id];
   prod.id=p.id;
   prod.price=p.price;
   prod.type=p.type;
   prod.billingPeriod=p.billingPeriod;
   prod.billingPeriodUnit=p.billingPeriodUnit;
   prod.currency=p.currency;
   prod.introPricePayment=p.introPricePaymentMode;
   prod.introPrice=p.introPrice;
   prod.introPricePeriod=p.introPricePeriod;
   prod.introPricePeriodUnit=p.introPricePeriodUnit;
   prod.state=p.state;
   if (p.state=='approved')
   {
    console.log ('Approved',p.id);
   }
   prod.priceMicros=p.priceMicros;
   prod.introPriceMicros=p.introPriceMicros;
   defined(p.expiryDate) && (prod.expiryDate);;
  
   defined(p.lastRenewDate) && (prod.lastRenewalDate=p.lastRenewalDate);
   defined(p.purchaseDate) && (prod.purchaseDate=p.purchaseDate);

   this.storeProducts[p.id]=prod;
  // if this state is valid, remove from saved purchases
  if (p.state=='valid')
  {
    this.removeSavedPurchase(p.id);
  }
   this.updateEvent.publish( this.store);
  });

 // alert("Getting Products")
 this.store.error ((e)=>
  {
    console.error(e);
  //  reject(e);
  });
  let all= this.products.concat(this.offers);
 all.forEach((p)=>

  {
   
    if ((p=='goldpass') || (p=='goldpass66'))
    {
      this.store.register({
        id: p,
        type: this.store.NON_CONSUMABLE,
      });
    }
    else
    {
      this.store.register({
        id: p,
        type: this.store.PAID_SUBSCRIPTION,
      });
    }
    
   
 
    this.store.get(p);
    
  });
 this.storeRefreshing=true;
 let promise1=this.store.refresh();
 promise1.finished(()=>{
  this.storeRefreshing=false;
  this.refreshComplete=true;resolve(0);
  this.initDelayed();
  this.productUpdateObserver.next(true);
      
this.updateEvent.publish(this.store)});
 promise1.cancelled(()=>{console.log("Refresh was canceled");});
 promise1.failed(()=>{
   // alert ("Restore products failed");
     
  
 });
});

return promise;
  

 
}

  checkAllprodInfoRcvd()
  {
    if (this.storeProducts['raagagold'] && (this.storeProducts['raagagold'].priceMicros >0 ) &&  this.storeProducts['raagagold'].state )
      return true;
      return false;
  }

/*

getPurchaseInfo()
{
 if (!this.iap)
 {
   return;
 }
  this.iap
  .getProducts(this.productList)
  .then((products) => {
    console.log(products);
     //  [{ productId: 'com.yourapp.prod1', 'title': '...', description: '...', price: '...' }, ...]
     this.products=products;
  })
  .catch((err) => {
    console.log(err);
  });
}
*/

buyMemberShip(membership):Promise <any>
{

  let promise=new Promise <any> ((resolve,reject)=>{

    this.iap
    .buy(membership)
    .then((data)=> {
      console.log(data);
      resolve(data)
    })
    .catch((err)=> {
    // alert(err)
     reject(err)
    });
  });
  return promise;

 
}

revenueCat;
iap=null;
readyInfo=false;
readyDevice=false;
readyBuild=false;
readyProduct=false;

settingsService :SettingsStore=null;
updateEvent:Event=null;
deviceType () {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};
ourDeviceType="mobile"
  constructor(private platform:Platform,public store:InAppPurchase2,private httpClient:HttpClient,private events:Events,private zone:NgZone
    ,private ga:GoogleAnalyticsService
  )
  {
  
   // this.revenueCat=new RevenuCat(this.platform,this.purchases);
    this.ourDeviceType=this.deviceType();
    

// detect orientation changes

//document.addEventListener("deviceready", this.deviceInit.bind(this), false);


this.updateEvent=events.create("appconfig:store");


  let appGlobalSettings=JSON.parse(localStorage.getItem(consts.GLOBAL_SETTINGS));
  if (appGlobalSettings && defined(appGlobalSettings) && defined(appGlobalSettings.startupShown))
  this.startUpShown=appGlobalSettings.startupShown;
  else
  this.startUpShown=false;

  let savedStr=window.localStorage.getItem('savedPurchase');

 
    if (savedStr) this.savedVerified=JSON.parse(savedStr);
  
   
this.getGifts();

this.initNow();

this.productUpdateObservable= new Observable<boolean>((observer)=>{
  this.productUpdateObserver=observer;
})

}
productUpdateObservable;
productUpdateObserver;
async initNow()
  {
   
      console.log('Platform feady');
      this.settingsService=new SettingsStore();
      Network.addListener('networkStatusChange', status => {
        console.log('Network status changed', status);
        this.connected=status.connected;
        this.connectType=status.connectionType;
      });
      let stat=await Network.getStatus();
          this.connected=stat.connected;
          this.connectType=stat.connectionType;

      this.deviceInit();
      this.getBuiltInSongs();
      
      Preferences.get({key:this.AD_ENABLED}).then(a=>
      {
        if (a.value=='Yes')
        this.adEnabled=true;

      });
      Preferences.get({key:'UNLOCK_BRONZE'})
      .then ((res)=>
      {
        if (res)
        {
          let ob=JSON.parse(res.value);
          if (ob)
          {
          this.bronzeUnlock.localDate=ob.localDate;
          this.bronzeUnlock.pts=ob.pts;
          }

        }

      });

      let p=await this.platform.ready().then(()=>{
        this.initDelayed();
      
  });
}

connected=false;
connectType=""
appWidth;
appHeight;
smallIos=false;
getSizes()
{
  this.appWidth= this.platform.width();
  this.appHeight= this.platform.height();
  if ((Capacitor.getPlatform()=='ios') || (Capacitor.getPlatform()=='web'))
  {
    if (this.appWidth > this.appHeight)
    {
      // landscape

      if (this.appHeight < 500)
        this.smallIos=true;
    }
    else
    {
      if (this.appWidth < 500)
      this.smallIos=true;
    }
  }
  document.addEventListener("deviceready", this.getBuildInfo.bind(this), false);

}

  async initDelayed()
  {

  this.getSizes();
 
    if (window.navigator && window.navigator.appInfo)
    {
    window.navigator.appInfo.getAppInfo((info)=>{
      this.appInfo=info;
      this.readyInfo=true;
    },(err)=>{

      console.log(err);
    });
    this.getDeviceInformation();
    //this.getAppVersion();
    this.getBuildInfo();
  // document.addEventListener("deviceready", this.getBuildInfo.bind(this), false);

  }
  }

  startShown()
  {
    this.startUpShown=true;
    this.saveGlobalSettings();
  }
  saveGlobalSettings()
  {
    let appGlobalSettings={
      startupShown:this.startUpShown
    };
    localStorage.setItem(consts.GLOBAL_SETTINGS,JSON.stringify(appGlobalSettings));
  }

  landScape=true;

  deviceInit()
  {
    if (defined(window.screen.orientation) ){
      this.landScape=false;
      if (window.screen.orientation.type.search(/landscape/i)==-1)
      {
        //alert ("Switch screen to landscape mode");
       //if (defined(window.screen.orientation.lock)) window.screen.orientation.lock('landscape');
        this.landScape=false;
      }
      else
      {
        this.landScape=true;
        //if (defined(window.screen.orientation.lock)) window.screen.orientation.lock('landscape');}
      }
    }
   
    if (defined(window.inAppPurchase))
    {
      this.iap=window.inAppPurchase;
    }
   
   
    if (Capacitor.getPlatform()!='web')
    {
      this.store.validator =
"https://validator.fovea.cc/v1/validate?appName=raagastudio&apiKey=f4be4a05-e1da-4d37-95cd-19dfc8db24ed";


    //setTimeout(this.getProducts.bind(this),1000);
   
    }

    //this.setupFireBase();
  

  
}

  getProductInfo()
  {

  }

  buyProduct(product)
  {
    let prom=new Promise((resolve,reject)=>{

    
    if (this.storeProducts[product] && (this.storeProducts[product].state=="valid") &&
     (!this.storeProducts[product].owned))
    {
      if (defined(this.storeProducts[product].canPurchase))
      {
        if(!this.storeProducts[product].canPurchase)
        {
        alert ("The product is not cleared for purchase by App STore.")
        return;
        }
      }
     
      this.store.when(product).approved( (p)=>{
      
       this.store.when(p).verified((p1)=>{p1.finish();resolve(p1);})
       p.verify();
       this.productUpdateObserver.next(true);

      });
      
      
      this.store.error((e)=>{
        //console.warn(e);
       // alert(e);
        //reject(e);
      });
      this.store.order(product).then (()=>{resolve(product);}).error((e)=>{
        reject(e);
      });
    }

    
    else
    {
      reject ("Bad product");

    }
  });
  return prom;

  }
  cancelMemberShip(product)
  {

  }
  
  setSettings(setting:SettingsRec)
  {
    this.currentSettings=setting;
  }

  getSettings()
  {
    return this.currentSettings;
  }
manageSubscriptions()
{
  this.store.manageSubscriptions();
}


async restorePurchases()
{
  let prom=new Promise((resolve,reject)=>{

  
  this.store.when("product").approved( (p)=>{
     this.store.error((p1)=>{
     //  p1.finish();
     })
    p.verify((p1)=>{
      p.finish();
      
   });
    
    
   });

  let restPromise=this.store.refresh().finished(()=>{resolve(null)});

  });
  return prom;
}
manageBilling()
{this.store.manageBilling();
}

freeAvailDate=new Date('12/31/2022');
freeDays=FREE_DAYS;
access48()
{
  let instDate=null;
  //if (this.accesss48Selected)
      {

    if (Capacitor.getPlatform()=='web')
    return true;
      }
   if (!this.buildInfo)

   {
    console.log("Build info not found");
    return false;
   }
    if (instDate=this.buildInfo.installDate)
    {
      
        let delta=Date.now() - Date.parse(instDate);
        if (delta < FREE_DAYS*3600* 24*1000)
          return true;
      }
     
    

    return false;
}

readyTimer;
serviceReady():Promise<boolean>
{
  let prom=new Promise <boolean>((resolve)=>{

   this.readyTimer= setInterval (()=>{
      if (this.readyBuild)
      {
        resolve(true);
        clearInterval(this.readyTimer)
      }
    },500)
  });

  return prom;
}

freeDaysLeft()
{
  
  
  let instDate=Date.now();;
  if (this.buildInfo)
 
 
  instDate=Date.parse(this.buildInfo.installDate);
  if (instDate)
    {
      
        let delta= +(FREE_DAYS*3600 *24*1000) +instDate -Date.now()
        if (delta <= 0)
          return 0;
        return ((delta/3600/1000/24).toFixed(2))
        
      }
      else
      {
        if (Capacitor.getPlatform()!='web')
        {
          alert ("Could not query install date");
        }
      }
  
}
accesss48Selected=false;
featureAvailable(featureName)
{
  
 if (Capacitor.getPlatform() =='web')
    return (true);
    if (featureName=='testfail')
    {
      return false;
    }

    if (featureName=='testpass')
    {
      return 'true';
    }
    let valid=this.bronzeFeatures.find((N)=>(N==featureName));
    if (!valid)
      return false;
  console.log(featureName);
  let time=new Date();
  if (this.access48())
  
    return true;
  if (this.bronzeUnlock && this.bronzeUnlock.localDate)
  {
    let d = new Date();
    let dateStr = d.getFullYear() + "-" + ("0" + d.getMonth()).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    if (dateStr==this.bronzeUnlock.localDate)
      return (true)
  }
  
 return this.purchased(featureName);

  
}

purchased(featureName?)
{

  if (this.storeProducts && this.storeProducts['raagagold'] && this.storeProducts['raagagold'].state=='owned')
  {
    return true;
  }
  if (this.storeProducts && this.storeProducts['goldpass'] && this.storeProducts['goldpass'].state=='owned')
  {
    return true;
  }
  if (this.storeProducts && this.storeProducts['goldpass'] && this.storeProducts['goldpass'].state=='approved')
  {
    return true;
  }
  if (this.storeProducts && this.storeProducts['ragaagoldquarter'] && this.storeProducts['ragaagoldquarter'].state=='owned')
  {
    return true;
  }
  if (this.storeProducts && this.storeProducts['goldpass66'] && this.storeProducts['goldpass66'].state=='approved')
  {
    return true;
  }
  if (this.storeProducts && this.storeProducts['goldpass66'] && this.storeProducts['goldpass66'].state=='owned')
  {
    return true;
  }


  if (this.savedVerified)
  {
    let purchase=this.savedVerified.find((a)=>(a.id=='raagagold'))
    if (purchase)
    {
      let datep=new Date(purchase.expiryDate);
      if (datep.getTime() >  Date.now())
      {
        return true;

      }
    }
     purchase=this.savedVerified.find((a)=>(a.id=='goldpass'))
    if (purchase)
    {
     return true;
    }
    purchase=this.savedVerified.find((a)=>(a.id=='goldpass66'))
    if (purchase)
    {
     return true;
    }
    purchase=this.savedVerified.find((a)=>(a.id=='ragaagoldquarter'))
    if (purchase)
    {
      let datep=new Date(purchase.expiryDate);
      if (datep.getTime() >  Date.now())
      {
        return true;

      }
    }
  }
  return false;
}
//signedInUser:User=null;
/*
setupFireBase()
{
 
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window would clear any existing state even
    // if a user forgets to sign out.
    // ...
    // New sign-in will be persisted with session persistence.
    //return signInWithEmailAndPassword(auth, email, password);
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
  });
  onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/firebase.User
      this.signedInUser=user;
      console.log('Signed in ',user)
      // ...
    } else {
      // User is signed out
      // ...
      this.signedInUser=null;
    }
  });
  setTimeout (()=>{
      if (!this.signedInUser) 
      {
          signInAnonymously(auth)
        .then(() => {
      // Signed in..
        })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorMessage);
      // ...
    });
  }
  },4000);

}
*/

//globalFunBoard=[];

lastSettings:SettingsRec;
setCureentSettings(rec:SettingsRec)
{
this.lastSettings=rec;
}
saveBoardSettings(rec)
{
let funBoards=JSON.parse(localStorage.getItem(consts.MY_FUN_BOARD));
  if (!funBoards)
  funBoards=[];
  let found=false;
  funBoards.forEach((board,index)=>
  {
    if (board.title == rec.title)
    {
      funBoards[index]=rec;
      found=true;
      return;
    }
  });
  if (!found)
  funBoards.push(rec);
  localStorage.setItem(consts.MY_FUN_BOARD,JSON.stringify(funBoards));
  localStorage.setItem(consts.LAST_SETTING,JSON.stringify(rec));
  this.lastSettings=rec;

  // copy  to current funboard list
 
}

getBoardList()
{
  let funBoards=JSON.parse(localStorage.getItem(consts.MY_FUN_BOARD));
  return funBoards;
}

catData=[];

async loadCategories()
{

  let catPromise= new Promise<any>((resolve, reject) => {


    // load templates
    let count=0;
      try {
        this.catData=[];
        this.httpClient.get("/assets/boardTemplates/all.json").subscribe(data =>{
          console.log(data);
          if (data && typeof(data)=='object')
          {
            let list=data as Array<any>;

          
            let countExpected=list.length;  
             let  templates=[];

            ( data as Array<any>).forEach(cat=>{
              
               // if (cat.cat=="Indian Thaat U Board")
               // return;
               // if (cat.cat=="Indian Raaga U Board")
               // return;
              if (cat.cat && cat.list)
              {

              
              cat.templates=[];
              
            this.getBoardTemplates(cat.list).then (
                (templ)=>{ cat.templates=templ;
              this.catData.push(cat);
              if (count==countExpected)
              resolve(this.catData);
                });
              }
              else count++;
            });
          }
          });
        }
          catch (error)
          {count++;
            console.warn(error)};
        
          
      
          

        });
        return catPromise;
      
}

async getBoardTemplates(list:[])
  {
    let templates=[];
    let countExpected=list.length;
    let count=0;
    let promise=new Promise ((resolve,reject)=>
    {
    list.forEach((board)=>{
  
      try {
        this.httpClient.get("/assets/boardTemplates/"+board).subscribe(board=>
          {
        
        
             templates.push(board);
             count++;
              if (count==countExpected)
              {
                templates=templates;
                resolve(templates)
              }
            });
          }
          catch (e)
          {
            console.warn(e);
            count++;
          }
        });
        
      
      });
      return promise;
    }
    buildInfo;
getBuildInfo()
{
   /*let buildPromise =this.platform.ready().then(() => 
   
   {*/

      if (window.BuildInfo && window.BuildInfo.installDate)
      {
      this.buildInfo=window.BuildInfo;
      this.readyBuild=true;
      }
      else
      {
        alert("Build infor not found");
        console.log("Build info not found");
      }
      
  //});
}

installDate()
{
  if (Capacitor.getPlatform()=='web')
  {
    return Date.now();

  }
  else
  {
    if (this.buildInfo)
      return this.buildInfo.installDate;
  }
  return Date.now();
}
removeSavedPurchase(id)
{
  if (this.savedVerified)
  {
    for (let j=0; j < this.savedVerified.length;j++)
    {
      let ob=this.savedVerified[j];
      if (id==ob.id) 

          this.savedVerified.splice(j,1);

        
      
    }
    window.localStorage.setItem('savedPurchase',
    JSON.stringify(this.savedVerified));

  }
}
addToVerified(option)
{
    if (!this.savedVerified)
    this.savedVerified=[];
   // this.savedVerified.push(option);
    let j=0;
    let add=true;
    for (j=0; j < this.savedVerified.length;j++)
    {
      let ob=this.savedVerified[j];
      if ((option.id==ob.id) && option.expiryDate==ob.expiryDate)
      add=false;

      if (ob.expiryDate)
      {
        let exp= new Date(ob.expiryDate);
        if (Date.now() > exp.getTime())
        {
          this.savedVerified.splice(j,1);

        }
      }
    }
    if (add)
    this.savedVerified.push(option);
    window.localStorage.setItem('savedPurchase',
    JSON.stringify(this.savedVerified));

}

builtinSongs;
async getBuiltInSongs()
{
  this.httpClient.get('/assets/builtinSongs.json').subscribe((d)=>
  {
    this.builtinSongs=d ;
    let ar=[];
    ar=d as [];
    console.log('songs builtin',ar.length)
  });
}

adEnabled=false;
AD_ENABLED='AD_ENABLED';
enableAds()
{
  this.adEnabled=true;
  Preferences.set({key:this.AD_ENABLED,value:"Yes"})
}
disableAds()
{
this.adEnabled=false;

  Preferences.set({key:this.AD_ENABLED,value:"No"})
}

bronzeUnlock={
  localDate:"",
  pts:0
}
addVideoPoints(type:UnlockTypes,
  amount:number)
  {
    let d = new Date();
    let dateStr = d.getFullYear() + "-" + ("0" + d.getMonth()).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);

if (type==UnlockTypes.UNLOCK_BRONZE_DAILY)
{
  // unlock for today.
  this.bronzeUnlock.localDate=dateStr,
  this.bronzeUnlock.pts=amount;
  Preferences.set({key:'UNLOCK_BRONZE',value:JSON.stringify(this.bronzeUnlock)})

}
  }

bronzeFeatures=[
  Features.SYNTH,
  Features.TESTFAIL,
  Features.RECORD,
  Features.TAANPURA,
  Features.TABLA,
  Features.UBOARD,
  Features.DBL_PIANO,
  Features.ROLI_BOARD,
  Features.THAAT_LAYOUT,
  Features.RAAGA_LAYOUT,
  Features.SONG_LAYOUT,
  Features.RAAGA_INFO,
];
silverFeatures=[

];
goldFeatures=[];

rewardAdUnlocked():string
{
  if (this.bronzeUnlock && this.bronzeUnlock.localDate)
  {
    let d = new Date();
    let dateStr = d.getFullYear() + "-" + ("0" + d.getMonth()).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    if (dateStr==this.bronzeUnlock.localDate)
      return (dateStr)
  }
  if (Capacitor.getPlatform()=='web')
  {
    return ("2999-01-01")
  }
  else return "";
}
skuLockStatus(sku:string)
{
  let d=Math.random();
  d=d*1000;
  let x=Math.trunc(d)%3;
  if (x==0)
  {
    return ProductStatus.Locked;
  }
  if (x==1)
  {
    return (ProductStatus.Allowed);
  }
  if (x==2)
  {
    return (ProductStatus.Purchased);
  }
}
}





